import { render, staticRenderFns } from "./restaurantUseCoupon.vue?vue&type=template&id=4d766f1d&scoped=true&"
import script from "./restaurantUseCoupon.vue?vue&type=script&lang=js&"
export * from "./restaurantUseCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d766f1d",
  null
  
)

export default component.exports